export default __webpack_public_path__ + "svg/CompaniesLogos/logo_transparent-edge.svg?46b06411";